<template>
<div class=" mx-auto">
  <div class="">
    <Loading :isLoading="this.isLoading" />
    <Modal v-show="showModalSendCodeCellphone" :heightContainer="'auto'" :widthContainer="'25%'">
      <template v-slot:header><h3 class="text-lg" style="font-family:Roboto;color:#810042;">Favor de introducir el código de verificación enviado a su celular</h3></template>
      <template v-slot:body>
        <form v-if="isValidToContinue" @submit="validateInputCellPhone">
          <div class="text-left my-3 mx-2">
            <label class="label-input">Código:</label>
              <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor inputText" style="text-transform: uppercase;"
              minlength="5" maxlength="5" @keyup="validateVerificationCode()" onKeyPress="if(this.value.length==5) return false;" min="0" v-model="codeCellphone"  id="phoneDatosPersonalesUpdate">
            </div>
            <div class="md:grid md:grid-cols-4 grid grid-cols-1 gap-x-20">
              <div class="md:col-span-4">
                <button class="verifyButton" style="float:right;">Verificar</button>
                <input type="button" value="Cancelar" class="verifyButtonWithoutBackground" @click="showModalSendCodeCellphone = false" style="float:right;margin-right:10px;">
              </div>
          </div>
        </form>
      </template>
    </Modal>
    <Modal v-show="showModalTermsGeolocation" :heightContainer="'auto'" :widthContainer="'40%'">
      <template v-slot:body>
        <div style="margin-bottom:30px;display:flex;justify-content:center;">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="80.182" height="89.138" viewBox="0 0 150 160.994">
              <g id="geolocalizacion" transform="translate(-17.14)">
                <g id="Group_374" data-name="Group 374" transform="translate(17.14)">
                  <g id="Group_373" data-name="Group 373" transform="translate(0)">
                    <path id="Path_595" data-name="Path 595" d="M102.824,272.164H95.148a3.213,3.213,0,0,0,0,6.425h7.676a3.213,3.213,0,0,0,0-6.425Z" transform="translate(-67.952 -184.886)" fill="#688977"/>
                    <path id="Path_596" data-name="Path 596" d="M153.984,59c8.73-13.809,13.156-24.063,13.156-30.478a28.526,28.526,0,0,0-56.654-4.751A70.474,70.474,0,1,0,152.111,61.92Q153.041,60.5,153.984,59Zm-15.37-52.59a22.137,22.137,0,0,1,22.112,22.112c0,9.44-14.19,30.829-22.112,41.68C130.691,59.357,116.5,37.971,116.5,28.526A22.137,22.137,0,0,1,138.614,6.414Zm-28.4,24.077c.771,6.463,5.144,16.037,13.031,28.513,6.334,10.019,12.562,18.171,12.824,18.514a3.207,3.207,0,0,0,5.092,0c.173-.226,2.949-3.86,6.639-9.187a63.375,63.375,0,0,1,3.851,18.953H116.141c-.3-17.153-2.965-33.208-7.593-45.507a52.631,52.631,0,0,0-7.457-13.962A63.533,63.533,0,0,1,110.213,30.491ZM87.643,26.4c10.16,0,21.446,24.839,22.082,60.881H72.651a3.207,3.207,0,0,0,0,6.414h37.074a156.829,156.829,0,0,1-2.641,26.622,70.866,70.866,0,0,0-38.883,0,159.432,159.432,0,0,1-2.671-29.828,159.771,159.771,0,0,1,2.61-29.509,70.695,70.695,0,0,0,19.5,2.733A71.1,71.1,0,0,0,100.9,62.47a3.207,3.207,0,1,0-1.2-6.3A64.638,64.638,0,0,1,87.643,57.3,64.251,64.251,0,0,1,69.5,54.7C73.808,37.125,80.969,26.4,87.643,26.4ZM74.184,27.829a52.669,52.669,0,0,0-7.445,13.947,98.549,98.549,0,0,0-3.325,10.789A63.861,63.861,0,0,1,45.936,41.872,63.931,63.931,0,0,1,74.184,27.829ZM23.635,93.7H33.34a3.207,3.207,0,1,0,0-6.414H23.635A63.871,63.871,0,0,1,41.26,46.308a70.248,70.248,0,0,0,20.746,12.6,166.492,166.492,0,0,0-2.89,31.58,166.173,166.173,0,0,0,2.951,31.894,70.3,70.3,0,0,0-20.63,12.471A63.874,63.874,0,0,1,23.635,93.7Zm22.5,45.577a63.9,63.9,0,0,1,17.36-10.549,98.3,98.3,0,0,0,3.248,10.48,52.669,52.669,0,0,0,7.445,13.947A63.926,63.926,0,0,1,46.13,139.275Zm41.514,15.3c-6.634,0-13.749-10.594-18.065-27.981a64.4,64.4,0,0,1,36.129,0C101.391,143.986,94.277,154.58,87.643,154.58Zm13.459-1.426a52.67,52.67,0,0,0,7.445-13.947,98.262,98.262,0,0,0,3.248-10.479,63.912,63.912,0,0,1,17.359,10.549A63.927,63.927,0,0,1,101.1,153.153Zm32.746-18.3a70.322,70.322,0,0,0-20.63-12.47A163.752,163.752,0,0,0,116.141,93.7h35.51A63.872,63.872,0,0,1,133.848,134.856Z" transform="translate(-17.14)" fill="#688977"/>
                    <path id="Path_597" data-name="Path 597" d="M376.475,52.038A17.47,17.47,0,1,0,359,69.508,17.49,17.49,0,0,0,376.475,52.038Zm-28.515,0A11.045,11.045,0,1,1,359,63.083,11.057,11.057,0,0,1,347.96,52.038Z" transform="translate(-237.581 -23.462)" fill="#688977"/>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div style="display:flex;flex-direction:row;flex-wrap:wrap;justify-content:center;text-align:center;">
          <div class="w-full">
            <p style="font-size:16px;font-family:Roboto;font-weight:300;color:#726659;">Por disposición oficial recabaremos la ubicación de tus operaciones.</p>
          </div>
          <div class="w-full">
            <p style="font-size:16px;font-family:Roboto;font-weight:700;color:#726659;">¿Permitir que FONCABSA acceda a mi ubicación actual?</p>
          </div>
          <div class="w-full">
            <p style="font-size:16px;font-family:Roboto;font-weight:300;color:#726659;">Esta medida reforzaría la seguridad de tu cuenta al saber que eres tú quien ingresa a FONCABSA.</p>
          </div>
          <div class="flex">
            <div class="w-full mx-5 mt-10">
              <input type="button" class="regresar allow_button" value="Permitir" 
                v-on:click="termsGeolocation(true, false)"/>
            </div>
            <div class="w-full mx-5 mt-10">
              <input type="button" class="register disallow_button" value="No permitir"
                v-on:click="termsGeolocation(false, false)"/>
            </div>
          </div>
        </div>
      </template>
    </Modal>
    <Modal v-show="showModalTermsGeolocationConfirmation" :heightContainer="'auto'" :widthContainer="'40%'">
      <template v-slot:body>
        <div style="margin-bottom:30px;display:flex;justify-content:center;">
          <div>
            <svg xmlns="http://www.w3.org/2000/svg" width="80.182" height="89.138" viewBox="0 0 122.182 131.138">
              <g id="geolocalizacion" transform="translate(-17.14)">
                <g id="Group_374" data-name="Group 374" transform="translate(17.14)">
                  <g id="Group_373" data-name="Group 373" transform="translate(0)">
                    <path id="Path_595" data-name="Path 595" d="M100.789,272.164H94.547a2.612,2.612,0,0,0,0,5.225h6.242a2.612,2.612,0,0,0,0-5.225Z" transform="translate(-72.396 -201.067)"/>
                    <path id="Path_596" data-name="Path 596" d="M128.607,48.062c7.111-11.248,10.716-19.6,10.716-24.826a23.236,23.236,0,0,0-46.148-3.87,57.4,57.4,0,1,0,33.906,31.071Q127.838,49.276,128.607,48.062ZM116.087,5.225A18.031,18.031,0,0,1,134.1,23.236c0,7.689-11.558,25.112-18.011,33.95-6.453-8.837-18.011-26.256-18.011-33.95A18.031,18.031,0,0,1,116.087,5.225ZM92.953,24.836c.628,5.265,4.19,13.063,10.615,23.225,5.159,8.161,10.232,14.8,10.446,15.08a2.612,2.612,0,0,0,4.148,0c.141-.184,2.4-3.144,5.407-7.483A51.622,51.622,0,0,1,126.705,71.1H97.781c-.241-13.972-2.415-27.05-6.185-37.068a42.871,42.871,0,0,0-6.074-11.373A51.751,51.751,0,0,1,92.953,24.836Zm-18.384-3.33c8.276,0,17.469,20.232,17.987,49.591h-30.2a2.612,2.612,0,1,0,0,5.225h30.2A127.745,127.745,0,0,1,90.4,98.007a57.724,57.724,0,0,0-31.672,0,129.865,129.865,0,0,1-2.175-24.3,130.141,130.141,0,0,1,2.126-24.036A57.584,57.584,0,0,0,74.568,51.9a57.914,57.914,0,0,0,10.8-1.014,2.612,2.612,0,1,0-.977-5.133,52.651,52.651,0,0,1-9.823.922,52.335,52.335,0,0,1-14.779-2.119C63.3,30.241,69.132,21.507,74.569,21.507ZM63.605,22.669a42.9,42.9,0,0,0-6.065,11.361,80.273,80.273,0,0,0-2.708,8.788A52.018,52.018,0,0,1,40.6,34.106,52.075,52.075,0,0,1,63.605,22.669ZM22.43,76.322h7.906a2.612,2.612,0,1,0,0-5.225H22.43A52.026,52.026,0,0,1,36.787,37.721a57.221,57.221,0,0,0,16.9,10.265A135.616,135.616,0,0,0,51.332,73.71a135.356,135.356,0,0,0,2.4,25.98,57.267,57.267,0,0,0-16.8,10.158A52.029,52.029,0,0,1,22.43,76.322Zm18.323,37.124a52.048,52.048,0,0,1,14.141-8.593,80.075,80.075,0,0,0,2.646,8.536A42.9,42.9,0,0,0,63.6,124.751,52.071,52.071,0,0,1,40.754,113.446Zm33.815,12.466c-5.4,0-11.2-8.629-14.715-22.792a52.456,52.456,0,0,1,29.429,0C85.767,117.284,79.972,125.913,74.569,125.913Zm10.963-1.162A42.9,42.9,0,0,0,91.6,113.39a80.038,80.038,0,0,0,2.645-8.535,52.06,52.06,0,0,1,14.14,8.593A52.071,52.071,0,0,1,85.532,124.751Zm26.673-14.9A57.281,57.281,0,0,0,95.4,99.69a133.384,133.384,0,0,0,2.381-23.368h28.925A52.027,52.027,0,0,1,112.2,109.847Z" transform="translate(-17.14)"/>
                    <path id="Path_597" data-name="Path 597" d="M369.945,48.773A14.205,14.205,0,1,0,355.74,62.979,14.221,14.221,0,0,0,369.945,48.773Zm-23.186,0a8.981,8.981,0,1,1,8.981,8.981A8.991,8.991,0,0,1,346.759,48.773Z" transform="translate(-256.793 -25.538)"/>
                  </g>
                </g>
              </g>
            </svg>
          </div>
        </div>
        <div style="display:flex;flex-wrap: wrap;justify-content:center;text-align:center;">
          <div>
            <p style="font-size:16px;font-family:Roboto;font-weight:300;">Para poder iniciar con el tramite es necesario que nos de acceso a su geolocalización.</p>
          </div>
          <div>
            <p style="font-size:16px;font-family:Roboto;font-weight:500;">¿Permitir que FONCABSA acceda a mi ubicación actual?</p>
          </div>
        </div>
        <div style="display:flex;flex-wrap: wrap;justify-content:center;text-align:center;">
          <div style="margin-top:15px;">
            <input type="button" class="regresar md:float-right" value="Permitir" style="text-decoration:none;font-family:Roboto;font-size: 16px;color:#FFFFFF;padding-top:5px;padding-bottom:5px;padding-left:55px;padding-right:55px;background-color:#FEB72B;border: 0px solid;border-width: 3px;border-radius:35px;"
              v-on:click="termsGeolocation(true, true)"/>
          </div>
          <div style="margin-top:16px;">
            <input type="button" class="register md:float-left" value="No permitir" style="text-decoration:none;font-family:Roboto;font-weight:300;font-size: 16px;color:#000;padding-top:5px;padding-bottom:5px;padding-left:55px;padding-right:55px;background-color:#FFF;border: 1px solid gray;border-width: 1px;border-radius:35px;"
              v-on:click="termsGeolocation(false, true)"/>
          </div>
        </div>
      </template>
    </Modal>
    <div>
      <form v-if="isValidToContinue" @submit="Next" id="formRegistroDatosPersonales" class="px-0 md:px-8 pt-6 pb-8 mb-4" style="text-align: left;" autocomplete="off">
        <br>
        <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
          <div class="row">
            <center>
              <p class="title">
                Registro de Datos Personales</p>
            </center>
          </div>
        </div>
        <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
          <div class="row">
            <center>
              <p v-if="errors.length">
                <ul>
                  <li v-for="(index,error) in errors" :key="index">
                    <h5 style="color:red">{{
    error
  }}</h5>
                   </li>
                 </ul>
               </p>
               <br>
             </center>
           </div>
         </div>
         <br>
         <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
           <div class="row">
             <center>
               <p v-show="allowGeolocation" class="subTitle" style="margin-top:-20px;">
                 Validación de identidad</p>
             </center>
           </div>
         </div>
         <div>
           <!-- v-show="callMatiStatusVerification() != 'verified'" -->
           <p v-show="!user_is_validated && allowGeolocation" class="text-2xl lg:text-2xl xl:text-2xl" style="color: gray; text-align:center;">El proceso de verificación de identidad puede tardar varios minutos</p>
         </div>
         <br>
         <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
           <div class="row">
             <center>
               <!-- v-if="callMatiStatusVerification() != 'verified'" -->
               <div v-show="!user_is_validated && allowGeolocation">
                <div v-html="matiButton()"></div>
               </div>
             </center>
            </div>
            <h4 v-show="allowGeolocation" class="text-base lg:text-base xl:text-base mt-5 text-center">Paso 1 de 10</h4>
         </div>
         <br>
         <div v-show="continuedRegistration">
           <div class="flex-1 bg-gray-0 px-0 py-1 m-1">
             <div class="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lx:grid-cols-2" v-show="user_is_validated">
               <!-- v-show="callMatiStatusVerification() == 'verified'" -->
               <div class="border" v-show="numberIdentification != '' || matiDocumentNumber != ''">
                 <div class="text-left my-3 mx-2">
                   <label style="text-align: left;font-size:15px;color:black;color: #6E6E6E;">Tipo de identificación:</label>
                   <div class="input-group" style="margin-top:-5px;">
                     <!-- <input type="radio" name="rdbIdentificacion" v-on:change="showImageTypeIdentication()" value="INE/IFE" v-model="typeIdentification" required> INE/IFE
                                             <input type="radio" name="rdbIdentificacion" v-on:change="showImageTypeIdentication()" value="PASAPORTE" v-model="typeIdentification" style="margin-left:10px"> Pasaporte <br>
                                             <input type="radio" name="rdbIdentificacion" v-on:change="showImageTypeIdentication()" value="CÈDULA PROFESIONAL" v-model="typeIdentification" > Cédula Profesional
                                             <input type="radio" name="rdbIdentificacion" v-on:change="showImageTypeIdentication()" value="CÈDULA DE RESIDENCIA" v-model="typeIdentification" style="margin-left:10px"> Cédula de Residencia -->
                     <label style="text-align: left;font-size:25px;color:black;color: #6E6E6E;" for="">{{
    documentType
  }}</label>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="flex grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lx:grid-cols-1">
                   <div class="row" style="margin-left:24px;margin-right:10px">
                     <div id="imgIdentificationProfessional" style="display:none;">
                       <img alt="cedula-profesional" src="../../assets/Identifications/cedula-profesional.png">
                     </div>
                     <div id="imgIdentificationResidence" style="display:none;">
                       <img alt="cedula-residencial" src="../../assets/Identifications/cedula-residencial.png">
                     </div>
                     <div id="imgIdentificationIneIfe" style="display:none;">
                       <img alt="ine-ife.png" src="../../assets/Identifications/ine-ife.png">
                     </div>
                     <div id="imgIdentificationPassport" style="display:none;">
                       <img alt="pasaporte" src="../../assets/Identifications/pasaporte.png">
                     </div>
                   </div>
                   <div class="row" id="typeIdentification" style="margin-left:24px; margin-top:0px;margin-right:10px" v-show="numberIdentification != '' || matiDocumentNumber != ''">
                     <div class="center mr-0 md:mr-7">
                       <div class="text-left my-3 mx-2" style="text-align: left;margin-top:-15px; margin-top:5px">
                         <label class="label-input" v-if="numberIdentification != ''">Número de Identificación: </label>
                         <label class="label-input" v-else-if="matiDocumentNumber!= ''">Número de Pasaporte:</label>
                         <br>
                         <label for="" class="label-description" style="text-align:left;" v-if="numberIdentification != ''">{{
                            numberIdentification
                          }}
                         </label>
                         <label for="" class="label-description" style="text-align:left;" v-else-if="matiDocumentNumber!= ''">{{
                            matiDocumentNumber
                          }}
                         </label>
                         <!-- <input type="text" style="border:1px solid #bfd243;margin-top:-0.5px;widght:120px;
                                                     border:1px solid #bfd243;margin-top:-5px; border-top-left-radius:5px; border-top-right-radius:5px;
                                                     border-bottom-right-radius:5px;border-bottom-left-radius:5px; text-transform: uppercase;" class="form-control"
                                                     minlength="15" maxlength="40" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚ]{}" v-model="numberIdentification" required> -->
                       </div>
                     </div>
                   </div>
                   <div class="row" id="typeIdentification" style="margin-left:24px; margin-top:0px;margin-right:10px" v-show="numberIdentification != '' || matiDocumentNumber != ''">
                     <div class="center mr-0 md:mr-7">
                       <div class="text-left my-3 mx-2" style="text-align: left;margin-top:-15px; margin-top:5px">
                         <img alt="validado" :src="`${$publicPath}images/banners/validado.png`" style="height:60px; float:left; margin-right:15px" />
                         <label class="label-input" v-if="registerExist">Coincidencia del rostro:</label>
                         <br>
                         <label for="" class="label-description" style="text-align:left;" v-if="registerExist">{{
                              percentageVerified
                            }}%
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <br>
            <div id="personalInformationSection" class="flex-1 bg-gray-0 px-0 py-0 m-0">
              <div class="row">
                <center>
                  <p class="subTitle" style="margin-top:-20px;">
                    Informaci&oacute;n personal</p>
                </center>
              </div>
            </div>
            <div class="flex-1 bg-gray-0 px-0 py-1 m-1">
              <div class="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lx:grid-cols-2">
                <div class="border">
                  <div class="center mr-0 md:mr-7">
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Introduce tu R.F.C:</label>
                      <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" v-on:keyup="validityRFC()" minlength="13" maxlength="13" pattern="[a-zA-Z-0-9]{0,13}" id="rfc" v-model="rfc" required>
                    </div>
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Apellido Paterno:</label>
                      <input type="text" id="paternal" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="3" maxlength="30" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}" v-model="paternal" required>
                    </div>
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Apellido Materno:</label>
                      <input type="text" id="maternal" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="3" maxlength="30" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}" v-model="maternal">
                    </div>
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Primer Nombre:</label>
                      <input type="text" id="firstName" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="3" maxlength="30" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}" v-model="firstName" required>
                    </div>
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Segundo Nombre:</label>
                      <input type="text" id="lastName" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="3" maxlength="30" pattern="[a-zA-ZáéíóúÁÉÍÓÚñÑ\s]{1,30}" v-model="lastName">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="flex grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lx:grid-cols-1">
                    <div style="margin-left:-20px">
                      <div class="row" style="margin-left:50px; margin-top:10px">
                        <div class="text-left my-3 mx-2">
                          <label class="label-input" style="text-align:left;">Género:</label>
                          <div class="input-group" style="margin-top:-5px;">
                            <input type="radio" id="genderF" name="rdbSexo" value="FEMENINO" v-model="gender" @change="validateGender()"/> <label class="label-input-radio" style="margin-left:5px;">Femenino</label> 
                            <input type="radio" id="genderM" name="rdbSexo" value="MASCULINO" v-model="gender" style="margin-left:10px" @change="validateGender()" /> <label class="label-input-radio" style="margin-left:5px;">Masculino</label>
                            <br> <small v-if="!genderStatus" class="errors">Campo requerido</small>
                          </div>
                        </div>
                      </div>
                      <div class="row" style="margin-left:50px; margin-top:0px">
                        <div class="text-left my-3 mx-2">
                          <label class="label-input" style="text-align:left;">Fecha de nacimiento:</label>
                          <br>
                          <label class="label-description" style="text-align:left;">{{ this.birthday }}</label>
                        </div>
                        <div class="text-left my-3 mx-2">
                          <label class="label-input" style="text-align:left;">CURP:</label>
                          <br>
                          <label class="label-description" style="text-align:left;">{{ this.curp }}</label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <br>
            <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
              <div class="row">
                <center>
                  <p class="subTitle" style="margin-top:-20px;">
                    Lugar de Nacimiento</p>
                </center>
              </div>
            </div>
            <div class="flex-1 bg-gray-0 px-0 py-1 m-1">
              <div class="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lx:grid-cols-2">
                <div class="border">
                  <div class="center mr-0 md:mr-7">
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Estado:</label>
                      <select lang="en" translate="no" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor notranslate" ref="stateSelected" required v-model="stateNac" @change="changeValueState()">
                        <option v-for="state in list_states" v-bind:value="addUpperCase(state.nombre)" :key="state.nombre">
                        {{ addUpperCase(state.nombre) }}
                        </option>
                     </select>
                   </div>
                   <div class="text-left my-3 mx-2">
                     <label class="label-input">Municipio:</label>
                     <select lang="en" translate="no" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor notranslate" ref="municipalitySelected" required v-model="municipalityNac" @change="changeValue()">
                       <option v-for="municipality in list_municipalities" v-bind:value="addUpperCase(municipality.nombre)" :key="municipality.nombre">{{
    addUpperCase(municipality.nombre)
  }}</option>
                     </select>
                   </div>
                   <div class="text-left my-3 mx-2">
                     <label class="label-input">Ciudad:</label>
                     <!-- <input type="text" style="border:1px solid #bfd243; text-transform: capitalize;margin-top:-0.5px;widght:120px
                                             border:1px solid #bfd243;margin-top:-5px; border-top-left-radius:5px; border-top-right-radius:5px;
                                             border-bottom-right-radius:5px;border-bottom-left-radius:5px; text-transform: uppercase;" class="form-control"
                                             minlength="4" maxlength="30" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚ]{}" v-model="cityNac" required> -->
                     <select lang="en" translate="no" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor notranslate" ref="citySelected" :required="isRequired ? true : false" v-model="cityNac">
                       <option v-for="city in list_cities" v-bind:value="addUpperCase(city.nombre)" :key="city.nombre">{{
    addUpperCase(city.nombre)
  }}</option>
                     </select>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="flex grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lx:grid-cols-1">
                   <div class="row" style="margin-left:24px; margin-top:0px;margin-right:10px">
                     <div class="center mr-0 md:mr-7">
                       <div class="text-left my-3 mx-2">
                         <label class="label-input">País:</label>
                         <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="4" maxlength="30" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]{4,30}" v-model="countryNac" required>
                       </div>
                       <div class="text-left my-3 mx-2" style="text-align: left;margin-top:-15px; margin-top:-2px">
                         <label class="label-input">Nacionalidad:</label>
                         <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="4" maxlength="30" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]{4,30}" v-model="nacionalityNac" required>
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
             </div>
           </div>
           <br>
           <br>
           <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
             <div class="row">
               <center>
                 <p class="subTitle" style="margin-top:-20px;">
                   Datos de Dirección</p>
               </center>
             </div>
           </div>
           <div class="flex-1 bg-gray-0 px-0 py-1 m-1">
             <div class="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lx:grid-cols-2">
               <div class="border">
                 <div class="center mr-0 md:mr-7">
                   <div class="text-left my-3 mx-2">
                      <label class="label-input">Calle:</label>
                      <input type="text" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="4" maxlength="50" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]{4,50}" v-model="street" v-on:blur="validateStreet()" required>
                      <span id="tooltipstext" class="tooltipstext">Si su domicilio no se encuentra entre calles, debe de <br /> agregar una referencia</span>
                   </div>
                   <div class="text-left my-3 mx-2">
                     <div class="tooltips">
                       <label class="label-input">Entre calle:</label>
                       <input type="text" id="tooltips" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="1" maxlength="50" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]{1,50}" v-on:blur="validateBetweenStreetOne()" v-model="between_street_one" required>
                       <span id="tooltipstext" class="tooltipstext">Si su domicilio no se encuentra entre calles, debe de <br /> agregar una referencia</span>
                     </div>
                   </div>
                   <div class="text-left my-3 mx-2">
                     <div class="tooltips">
                       <label class="label-input">Y calle:</label>
                       <input type="text" id="tooltips" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="1" maxlength="50" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]{1,50}" v-on:blur="validateBetweenStreetTwo()" v-model="between_street_two" required>
                       <span id="tooltipstext" class="tooltipstext">Si su domicilio no se encuentra entre calles, debe de <br /> agregar una referencia</span>
                     </div>
                   </div>
                   <div class="row">
                     <div class="col-sm-6">
                       <div class="text-left my-3 mx-2">
                         <label class="label-input">Número exterior:</label>
                         <input type="number" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" required minlength="1" maxlength="6" pattern="[0-9]{1,6}" min="0" oninput="validity.valid||(value='');" v-model="numberExt">
                       </div>
                     </div>
                     <div class="col-sm-6">
                       <div class="text-left my-3 mx-2">
                         <label class="label-input">Número interior:</label>
                         <input type="text" id="numberInt" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="1" maxlength="20" pattern="[a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ\s]{1,20}" v-model="numberInt">
                       </div>
                     </div>
                   </div>
                 </div>
               </div>
               <div class="row">
                 <div class="flex grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lx:grid-cols-1">
                   <div class="row" style="margin-left:24px; margin-top:0px;margin-right:10px">
                     <div class="center mr-0 md:mr-7">

                       <div class="text-left my-3 mx-2">
                         <label class="label-input">Código Postal:</label>
                         <input type="number" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" onKeyPress="if(this.value.length==5) return false;" min="0" oninput="validity.valid||(value='');" v-on:blur="validateCP()"
                                                     v-on:change="validateCP()"
                                                     v-model="postalCode" required>
                       </div>

                       <div class="text-left my-3 mx-2">
                         <label class="label-input">Colonia:</label>
                         <select lang="en" translate="no" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor notranslate" ref="stateSelected" required v-model="colony">
                           <option v-for="colony in list_colonys" v-bind:value="addUpperCase(colony.nombre)" :key="colony.nombre">{{
                              addUpperCase(colony.nombre)
                            }}</option>
                         </select>
                       </div>
                     </div>
                     <div class="row">
                       <div class="col-sm-6">
                         <div class="text-left my-3 mx-2" style="margin-left:5px">
                           <label class="label-input">Municipio:</label><br>
                           <label class="label-description" style="font-size:15px;text-transform: uppercase;">{{
                              this.municipality
                            }}</label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                          <div class="text-left my-3 mx-2" style="margin-left:5px">
                            <label class="label-input">Ciudad:</label><br>
                            <label class="label-description" style="font-size:15px;text-transform: uppercase;">{{
    this.city
  }}</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6">
                          <div class="text-left my-3 mx-2" style="margin-left:5px">
                            <label class="label-input">Estado:</label><br>
                            <label class="label-description" style="font-size:15px;text-transform: uppercase;">{{
    this.state
  }}</label>
                          </div>
                        </div>
                        <div class="col-sm-6">
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br>
            <br>

            <div class="flex-1 bg-gray-0 px-0 py-0 m-0">
              <div class="row">
                <center>
                  <p class="subTitle" style="margin-top:-20px;">
                    Datos de Contacto</p>
                </center>
              </div>
            </div>
            <div class="flex-1 bg-gray-0 px-0 py-1 m-1">
              <div class="flex grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lx:grid-cols-2">
                <div class="border">
                  <div class="center mr-0 md:mr-7">
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Teléfono Particular:</label>
                      <input class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" id="phone"
                             minlength="12" maxlength="12"  min="0" v-model="phone"  v-maska="'### ###-####'" @keyup="validateNumberPhone()" title="Debe tener 10 dígitos">
                    </div>
                    <div class="text-left my-3 mx-2">
                      <label class="label-input">Teléfono Celular:</label>
                      <input class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" id="cellphone"
                        v-maska="'### ###-####'"
                        minlength="12" maxlength="12"  min="0" v-model="cellphone" @keyup="validateNumberCellPhone()" required
                        title="Debe tener 10 dígitos">
                      <label class="cell-validated" v-show="isCellphoneVerified">Teléfono Celular Validado</label>
                      <label class="cell-validated" v-show="!isCellphoneVerified">Al dar clic en siguiente se enviará un código de verificación a su celular</label>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="flex grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 lx:grid-cols-1">
                    <div class="row" style="margin-left:24px; margin-top:0px;margin-right:10px">
                      <div class="center mr-0 md:mr-7">
                        <div class="text-left my-3 mx-2">
                          <label class="label-input">Correo electrónico:</label>
                          <input type="email" class="outline-none shadow-md border-2 rounded-lg py-2 w-full px-3 focus:border-cherryColor" minlength="1" maxlength="200" pattern="^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$" v-model="email" required>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <br>
            <br>

            <br>
            <div class="flex-1 bg-gray-0 px-0 py-0 m-0" style="">
              <!-- <h4 style="text-align:center;">Paso 1 de 7</h4> -->
              <div class="row">
                <center>
                  <button class="next_button" type="submit" id="nextButton">Siguiente</button>
                </center>
              </div>
            </div>
            <br>
          </div>
        </form>
      </div>
    </div>
    <!--<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.4.1/css/bootstrap.min.css">-->
    <!--<link href="../../node_modules/tailwindcss/dist/tailwind.min.css" rel="stylesheet"> -->
  </div>

</template>

<script>

import('@/assets/css/stylesheet.css');
import Modal from '@/components/Modal/Modal.vue';
import { mask, maska } from 'maska';

var geoMap = "";
import {
  getStatusVerificationMati,
  getDataVerificationMati,
  getAdmissionRequest,
  getAdmissionRequestOrCreate,
  getDataVerificationByProcess,
  saveRequest,
  validityRFC,
  setBirthday
} from "@/api/user";
import MenuLateral from "@/components/Cuenta/MenuLateral.vue";
import Loading from "@/components/Loading/VueLoading.vue";
import Swal from "sweetalert2";
import moment from "moment";
import jsonData from "@/assets/data.json";
import MatiResponse from "@/classes/MatiResponse";
import {  getTokenDecoden } from '@/helpers/tokenauth.js';
import AdmissionRequest from '@/classes/AdmissionRequest';

const documentsType = {
  "passport": "PASAPORTE",
  "national-id": "INE/IFE"
};

export default {
  data() {
    return {
      errors: [],
      list_states: [],
      list_cities: [],
      list_municipalities: [],
      list_colonys: [],
      personId: null,
      countryNac: "México",
      cityNac: "",
      stateNac: "",
      municipalityNac: "",
      nacionalityNac: "Mexicana",
      city: "",
      between_street_one: "",
      between_street_two: "",
      state: "",
      municipality: "",
      street: "",
      numberInt: "",
      numberExt: "",
      postalCode: "",
      typeIdentification: "",
      numberIdentification: "",
      id: "",
      colony: "",
      cellphone: "",
      phone: "",
      rfc: "",
      fullName: "",
      paternal: "",
      maternal: "",
      firstName: "",
      lastName: "",
      gender: "",
      genderStatus: true,
      email: "",
      birthday: "",
      curp: "",
      registerExist: false,
      isNumberIdentification: false,
      documentType: documentsType.ID,
      multiApi: process.env.VUE_APP_MULTIAPI,
      matiClientId: process.env.VUE_APP_MATI_CLIENTID,
      matiClientSecretId: "65TWRPNX722UXTFHZHHVPC64PE1NK67R",
      matiuserid: "",
      business: "foncabsa",
      matiMail: "enoc.sanchez@gcabsa.com.mx",
      matiFlowid: process.env.VUE_APP_MATI_ID_AND_BIOMETRICS,
      matiRfc: "SAPE860304H13",
      matiDocumentNumber: "",
      matiFacematch: "",
      matiStatusVerification: "",
      intervalID: null,
      countInterval: 0,
      requestDone: true,
      isLoading: false,
      percentageVerified: 0,
      mati_identity_id: null,
      isRequired: true,
      continuedRegistration: false,
      responseVerificationMati: null,
      user_id: null,
      admission_id: "",
      admission_registration_date: "",
      mati_verification_table_type: "admission_requests",
      user_is_validated: null,
      ccapi: process.env.VUE_APP_CCAPI,
      count: 0,
      data_verification_id:null,
      status_admission:null,
      admission_status:null,
      codeCellphone:null,
      isCellphoneVerified:false,
      isCodeSent:false,
      cont: 0,
      showModalSendCodeCellphone: false,
      showModalTermsGeolocation: false,
      showModalTermsGeolocationConfirmation: false,
      allowGeolocation: false,
      clientClassification: "",
      geolocation: "",
      clickButtonMati: false,
      admission_information: {},
      matiObject: null,
      isValidToContinue: true,
      admissionRequestObject: new AdmissionRequest()
    };
  },
  name: "RegistrarDatosPersonal",
  components: {
    Loading,
    MenuLateral,
    Modal,
  },
  props: {
    msg: String,
  },
  directives: { maska },
  async created() {
    
    var auth = getTokenDecoden();
    this.fullName = `${auth.obj.person['name']} ${auth.obj.person['middle_name']} ${auth.obj.person['paternal_name']} ${auth.obj.person['maternal_name']}`
    this.user_id = auth["id"];
    this.apiToken = sessionStorage.getItem("login");
    this.email = auth.obj['email'];
    this.personId = auth.obj.person["id"];
      
    this.isValidToContinue = await this.validateProcess();
    if(this.isValidToContinue){
      this.checkAdmissionRequestRejected(); //revisa si id de solicitud es diferente a la que esta en admissionUser, si es diferente se elimina
      
      if (auth.obj["role"] == "member") {
        this.clientClassification = "educator";
      } else if (auth.obj["role"] == "cabsa_member") {
        this.clientClassification = "cabsa_employee";
      }
      
      await this.searchPersonalData();
          
      this.setToLocalStorageValidationMatiAttempts();
      this.matiObject = new MatiResponse();
    }
  },
  mounted() {
    document
        .getElementById("paternal")
        .addEventListener("keyup", ({detail}) => {
          var regex = /^[a-zA-ZÀ-ÿ\s]+$/;
          if (regex.test(this.paternal) != true) {
            this.paternal = this.paternal.replace(/[^a-zA-ZÀ-ÿ@\s]+/, "");
          }
        });

    document
        .getElementById("maternal")
        .addEventListener("keyup", ({detail}) => {
          var regex = /^[a-zA-ZÀ-ÿ\s]+$/;
          if (regex.test(this.maternal) != true) {
            this.maternal = this.maternal.replace(/[^a-zA-ZÀ-ÿ@\s]+/, "");
          }
        });

    document
        .getElementById("firstName")
        .addEventListener("keyup", ({detail}) => {
          var regex = /^[a-zA-ZÀ-ÿ\s]+$/;
          if (regex.test(this.firstName) != true) {
            this.firstName = this.firstName.replace(/[^a-zA-ZÀ-ÿ@\s]+/, "");
          }
        });

    document
        .getElementById("lastName")
        .addEventListener("keyup", ({detail}) => {
          var regex = /^[a-zA-ZÀ-ÿ\s]+$/;
          if (regex.test(this.lastName) != true) {
            this.lastName = this.lastName.replace(/[^a-zA-ZÀ-ÿ@\s]+/, "");
          }
        });

      document
        .getElementById("numberInt")
        .addEventListener("keyup", ({detail}) => {
          var regex = /^[a-zA-ZÀ-ÿ0-9\s]+$/;
          if (regex.test(this.numberInt) != true) {
            this.numberInt = this.numberInt.replace(/[^a-zA-ZÀ-ÿ0-9@\s]+/, "");
          }
        });
  },
  async beforeMount() {
    
    if(this.isValidToContinue){
      await this.loadInfo();
    }
    
  },
  watch: {
    street() {
      if (/[^a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]/.test(this.street)) {
        this.street = this.street.slice(0, this.street.length-1);
      }
    },
    between_street_one() {
      if (/[^a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]/.test(this.between_street_one)) {
        this.between_street_one = this.between_street_one.slice(0, this.between_street_one.length-1);
      }
    },
    between_street_two() {
      if (/[^a-zA-Z-0-9éñúóáÑÁÉÓÚíÍ ]/.test(this.between_street_two)) {
        this.between_street_two = this.between_street_two.slice(0, this.between_street_two.length-1);
      }
    },
    numberExt() {
      if (this.numberExt.length > 6) {
        this.numberExt = this.numberExt.slice(0, 6);
      }
    },
    numberInt() {
      if (this.numberInt.length > 20) {
        this.numberInt = this.numberInt.slice(0, 6);
      }
    },
    stateNac() {
      const self = this;
      if (this.stateNac == null) {
        return;
      }
      this.errors = "";
      this.axios
          .post(
              this.multiApi + "/Api/Catalogo/Sepomex/obtener_municipios_por_estado",
              {
                contenido: {
                  estado: this.stateNac,
                },
                withCredentials: true,
                headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                }
            },{
                auth: {
                  username: "multicr",
                  password: "*cabsa2018*",
                },
              }
          )
          .then((response) => {
            self.list_municipalities = response.data.municipios;
          })
          .catch((error) => {
          });
    },
    municipalityNac() {
      this.axios
          .post(
              this.multiApi +
              "/Api/Catalogo/Sepomex/obtener_ciudades_por_estado_y_municipio",
              {
                contenido: {
                  estado: this.stateNac,
                  municipio: this.municipalityNac,
                },
                withCredentials: true,
                headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                }
            },{
                auth: {
                  username: "multicr",
                  password: "*cabsa2018*",
                },
              }
          )
          .then((response) => {
            this.list_cities = response.data.ciudades;
            this.isRequired = true
            if (this.list_cities.length == 0) {
              this.list_cities = [{nombre: "N/A"}]
            }

            // if (this.list_cities.length > 0) {
            //   this.isRequired = true;
            // } else {
            //   this.isRequired = false;
            // }
          })
          .catch((error) => {
          });
    },
  },
  methods: {
    async validateVerificationCode(){
      var input = document.getElementById('phoneDatosPersonalesUpdate');
      

      var regex = /^([0-9])*$/
      var result = regex.test(input.value)
      input.oninvalid = input.setCustomValidity('');
      if(!result){
        input.value = input.value.toString().slice(0, -1)
      }
      if(input.value.length < 5){
        input.oninvalid = input.setCustomValidity('Favor de introducir el código de verificación a 5 digitos.');
      }
    },
    validateGender(){
      
      if(this.gender == ''){
        this.genderStatus = false;
        return false;
      }

      this.genderStatus = true;
      return true;
    },
    async validateNumberPhone(){
      var input = document.getElementById('phone');
      input.oninvalid = input.setCustomValidity('');
      if(input.value.length > 0 && input.value.length < 12){
        input.oninvalid = input.setCustomValidity('Debe ingresar los 10 dígitos del número');
      }
      this.validate_phone();
    },
    async validateNumberCellPhone(){
      var input = document.getElementById('cellphone');
      input.oninvalid = input.setCustomValidity('');
      if(input.value.length >= 0 && input.value.length < 12){
        input.oninvalid = input.setCustomValidity('Debe ingresar los 10 dígitos del número');
      }
      this.validate_phone();
    },
    validate_phone(){
      if(this.phone == "") {
       return false; 
      }
      if(this.cellphone == "") {
       return false; 
      }
      if(this.phone == this.cellphone){
        Swal.fire({
          icon:'warning',
          title:"Cuidado",
          text:"El Teléfono no puede ser el mismo que el Celular."
        });
        return true;
      }
      return false;
    },
    async validateCellphone(){
      if(this.cellphone.length == 12){
        if(this.isCellphoneVerified){
          return true;
        }
        await this.sendSMSwithCode();
        this.isCodeSent =true;
        if(this.isCodeSent){
          this.showWindowCode();
        }else {
          Swal.fire({
            title: "Aviso",
            customClass: {
              container: 'my-swal'
            },
            text: "Error al enviar el SMS",
            icon: "error",
            confirmButtonColor: '#FEB72B',
          });
        }
      }
      else{
        Swal.fire({
          title: "Aviso",
          customClass: {
            container: 'my-swal'
          },
          text: "El teléfono celular debe contener 10 dígtos.",
          icon: "error",
          confirmButtonColor: '#FEB72B',
        });
      }
    },
    validateInputCellPhone(e) {
      e.preventDefault();
      if (this.codeCellphone.length < 5) {
        Swal.fire({
          title: "Aviso",
          customClass: {
            container: 'my-swal'
          },
          text: "El código debe tener 5 dígitos",
          icon: "error",
          confirmButtonColor: '#FEB72B',
        });
        return;
      }
      if(this.cont == 3){
        Swal.close();
        Swal.fire({
          title: "Aviso",
          customClass: {
            container: 'my-swal'
          },
          text: "Ha excedido el número de intentos. ¿Desea recibir un nuevo código?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: '#FEB72B',
          cancelButtonColor: '#FEB72B',
          confirmButtonText: "Si",
          cancelButtonText: "No"
        }).then((result) => {
              if(result.value){
                this.validateCellphone();
                this.codeCellphone = "";
                this.cont = 0;
              } else {
                this.showModalSendCodeCellphone = false;
                this.cont = 0;
              }
            }
        );
        return;
      }
      this.cont++;
      this.validateCodeCellphone();
    },
    async showWindowCode(){
      this.showModalSendCodeCellphone = true;
      // const { value: code } = await Swal.fire({
      //   title: 'Favor de introducir el código de verificación enviado a su celular',
      //   input:"text",
      //   minlength: 5,
      //   maxlength:5,
      //   inputAttributes: {
      //     min: 0,
      //     max: 9
      //   },
      //   inputLabel: 'Código',
      //   confirmButtonText: "Aceptar",
      //   cancelButtonText: "Cancelar",
      //   showCancelButton: true,
      //   inputValidator: (value) => {
      //     if (!value) {
      //       return 'Es necesario ingresar un código'
      //     }
      //     if(value.length !=  5){
      //       return 'El código debe tener 5 dígitos'
      //     }
      //     this.codeCellphone = value;
      //     if(this.cont == 3){
      //       Swal.close();
      //       Swal.fire({
      //         title: "Aviso",
      //         text: "Ha excedido el número de intentos. ¿Desea recibir un nuevo código?",
      //         icon: "warning",
      //         showCancelButton: true,
      //         confirmButtonColor: '#FEB72B',
      //         confirmButtonText: "Si",
      //         cancelButtonText: "No"
      //       }).then((result) => {
      //             if(result.value){
      //               this.validateCellphone();
      //             }
      //           }
      //       );
      //       return;
      //     }
      //     this.cont++;
      //     this.validateCodeCellphone();
      //     var message = "";
      //     if(!this.isCellphoneVerified && this.cont < 4){
      //       message = 'El código ingresado es incorrecto, validación no realizada';
      //       return message;
      //     }
      //     if(!this.isCellphoneVerified){
      //       message ='Ha excedido el número de intentos, favor de intentarlo más tarde.';
      //       return message;
      //     }
      //   }
      // })
      // if (code) {
      //   Swal.fire(`Su código es ${code}`)
      // }
    },
    async sendSMSwithCode(){
      this.isLoading=true;
      await this.axios
          .post(this.ccapi + `/${process.env.VUE_APP_BUSINESS_FONCABSA}/admission_request_send`, {
              token_auth: sessionStorage.getItem("login"),
              admission_request_id: this.admission_id,
              phone_number: this.removeMask(this.cellphone),
              business: "foncabsa"
          })
          .then(() => {
            this.isCodeSent=true;
          })
          .catch((error) => {
            this.isCodeSent=false;
            console.log("Error al enviar el SMS: ", error);
            Swal.fire({
              title: "Aviso",
              customClass: {
                container: 'my-swal'
              },
              text: "Error al enviar el SMS",
              icon: "error",
              confirmButtonColor: '#FEB72B',
            });
          }).finally(()=>{
            this.isLoading=false;
          })
    },
    async validateCodeCellphone(){
      this.isLoading=true;
      
      return await this.axios
          .post(this.ccapi + `/${process.env.VUE_APP_BUSINESS_FONCABSA}/admission_request_verification`, {
              token_auth: sessionStorage.getItem("login"),
              admission_request_id: this.admission_id,
              code: this.codeCellphone
          })
          .then(() => {
            let self = this;
            return Swal.fire({
              title: "Aviso",
              customClass: {
                container: 'my-swal'
              },
              text: "Teléfono celular verificado correctamente",
              confirmButtonColor: '#FEB72B',
              icon: "success",
            }).then(() => {
              self.isCellphoneVerified=true;
              self.showModalSendCodeCellphone = false;
              document.getElementById("nextButton").click();
            });
          })
          .catch((error) => {
            this.isCellphoneVerified=false;
            
            if(!this.isCellphoneVerified && this.cont < 4){
              Swal.fire({
                title: "Aviso",
                customClass: {
                  container: 'my-swal'
                },
                text: "El código ingresado es incorrecto, validación no realizada",
                icon: "error",
                confirmButtonColor: '#FEB72B',
              });
              return;
            }

            if(!this.isCellphoneVerified){
              Swal.fire({
                title: "Aviso",
                customClass: {
                  container: 'my-swal'
                },
                text: "Ha excedido el número de intentos, favor de intentarlo más tarde.",
                icon: "info",
                confirmButtonColor: '#FEB72B',
              });
              return;
            }
            /*if(this.cont == 3) {
              Swal.fire({
                title: "Aviso",
                text: "Ha excedido el número de intentos, favor de intentarlo más tarde.",
                icon: "error",
              });
            }*/
             /*Swal.fire({
              title: "Aviso",
              text: "El código ingresado es incorrecto, validación no realizada. ¿Desea intentar de nuevo?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: '#FEB72B',
              confirmButtonText: "Si",
              cancelButtonText: "No"
            }).then((result) => {
              console.log();
                  if(result.value && this.cont < 3){
                    this.sendSMSwithCode();
                    this.cont++;
                  }
                }
            );*/
          }).finally(()=>{
        this.isLoading=false;
      })
    },
    async validityRFC() {
      if (this.rfc != null && this.rfc.length == 13) {

        await validityRFC(
            this.rfc
        )
        .then((response) => {
              this.setBirthday();
        })
        .catch((error) => {
              console.log("Error al validar el RFC: ", error);
              Swal.fire({
                title: "Aviso",
                text: "RFC no valido.",
                icon: "error",
                confirmButtonColor: '#FEB72B',
              });
         });
      }
    },
    async setBirthday() {
      await setBirthday(
          this.rfc
      )
          .then((response) => {
            this.birthday = this.orderDateByDayMonthYear(response.data.response.date,"-");
          })
          .catch((error) => {
            console.log("Error al validar la fecha de nacimiento: ", error);
            this.birthday = "";
          });
    },
    changeValue() {
      this.cityNac = "";
    },
    validateStreet(){
      if(this.street.toString().length < 4){
        Swal.fire({
            title: "Aviso",
            text:
                "La calle debe contener mínimo 4 caracteres",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
      }
    },
    validateBetweenStreetOne() {
      if (this.between_street_one != "") {
        if (
            this.addUpperCase(this.between_street_one) ==
            this.addUpperCase(this.between_street_two)
        ) {
          this.between_street_one = "";
          Swal.fire({
            title: "Aviso",
            text:
                "El valor de: (Entre Calle) y el valor: (Y Calle) no pueden ser iguales",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
        }
      }
    },
    validateBetweenStreetTwo() {
      if (this.between_street_two != "") {
        if (
            this.addUpperCase(this.between_street_two) ==
            this.addUpperCase(this.between_street_one)
        ) {
          this.between_street_two = "";
          Swal.fire({
            title: "Aviso",
            text:
                "El valor de: (Entre Calle) y el valor: (Y Calle) no pueden ser iguales",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
        }
      }
    },
    async validateCP() {
      if (this.postalCode != "") {
        if (this.postalCode != null && this.postalCode.toString().length == 5) {
          this.axios.post(this.multiApi + "/Api/Catalogo/Sepomex/obtener_colonias", {
                contenido: {
                  codigo_postal: this.postalCode.toString(),
                  colonia: ""
                },
              },
              {
                auth: {
                  username: "multicr",
                  password: "*cabsa2018*",
                },
              },
              {'Content-Type': 'application/json'})
              .then(response => {
                if (response.data.estado.nombre == "") {
                  Swal.fire({
                    title: "Aviso",
                    text: "Introduzca un código postal valido",
                    icon: "warning",
                    confirmButtonColor: '#FEB72B',
                  });
                }else {
                  this.list_colonys = response.data.colonias
                  this.municipality = response.data.municipio.nombre != null ? response.data.municipio.nombre : ""
                  this.state = response.data.estado.nombre != null ? response.data.estado.nombre : ""
                  if (response.data.ciudad.nombre != null) {
                    this.city = response.data.ciudad.nombre
                  } else {
                    this.city = "N/A"
                  }
                }
              }).catch(error => {
                Swal.fire({
                  title: "Aviso",
                  text: "Introduzca un código postal valido",
                  icon: "warning",
                  confirmButtonColor: '#FEB72B',
                });
                this.list_colonys = []
                this.municipality = ""
                this.state = ""
                this.city = ""
              });
        } else {
          this.list_colonys = [];
          this.municipality = ""
          this.state = "";
          this.city = "";
          
          Swal.fire({
            title: "Aviso",
            text: "Introduzca un código postal valido",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });

        }
      }
    },
    changeValueState() {
      this.municipalityNac = "";
      this.cityNac = "";
      this.list_cities = [];
    },
    Logout() {
      sessionStorage.clear();
      // window.location.href = "/";
      this.$router.push({path:"/"});
    },
    updateSessionStorage(prop, val) {
      let prevData = sessionStorage.getItem("login");
      switch (prop) {
        case "mati_identity_id":
          prevData.mati_identity_id = val;
          break;
      }
      sessionStorage.setItem("login", JSON.stringify(prevData));
    },
    insertContactInfo() {
      let contact_obj = {
        "celular": this.cellphone,
        "telefono particular": this.phone,
        "correo": this.email,
      };
      let contact_info = {},
          index = 0;
      for (const key in contact_obj) {
        if (contact_obj[key] != null && contact_obj[key] != "") {
          contact_info[index.toString()] = {
            contact_type: key,
            value: this.removeMask(contact_obj[key]),
            status: "activo",
            extension: ""
          };
          index++;
        }
      }
      return contact_info;
    },
    setPersonalInfoToLocalStorage(user_id, jsonPersonalInfo) {
      sessionStorage.setItem(user_id, JSON.stringify(jsonPersonalInfo));
    },
    getJsonFromLocalStorageBy(user_id) {
      let _json = JSON.parse(sessionStorage.getItem(user_id));
      if (_json == null) {
        _json = {};
      }
      return _json;
    },
    getStates() {
      this.axios
          .post(
              this.multiApi + "/Api/Catalogo/Sepomex/obtener_estados",
              {
                withCredentials: true,
                headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                }
            },{
                auth: {
                  username: "multicr",
                  password: "*cabsa2018*",
                },
              }
          )
          .then((response) => {
            this.list_states = response.data.Estados;
          });
    },
    validateRfc(rfc) {
      var regex = /^[A-ZÑ&]{3,4}\d{6}(?:[A-Z\d]{3})?$/;
      var results = regex.test(rfc);
      return results;
    },
    removeWhiteSpaceDateString(date) {
      return date.replace(/\s/, "T");
    },
    formatDate(date) {
      var d = new Date(this.removeWhiteSpaceDateString(date));
      var month = "" + (d.getMonth() + 1);
      var day = "" + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [day, month, year].join("/");
    },
    removeMask(phone) {
      if (phone.includes("(")) {
        phone = phone.replace("(", "");
      }
      if (phone.includes(")")) {
        phone = phone.replace(")", "");
      }
      if (phone.includes("-")) {
        phone = phone.replace("-", "");
      }
      if (phone.includes(" ")) {
        phone = phone.replace(" ", "");
      }
      return phone;
    },
    addUpperCase(value) {
      if (value != "") {
        value = value.toUpperCase();
      }
      return value;
    },
    addLowerCase(value) {
      if (value != "") {
        value = value.toLowerCase();
      }
      return value;
    },
    async showImageTypeIdentication() {
      var document5 = document.getElementById("typeIdentification");
      document5.style.marginTop = "-10px";
      var document1 = document.getElementById("imgIdentificationProfessional");
      document1.style.display = "none";
      document1.style.width = "0px";
      document1.style.height = "0px";

      var document2 = document.getElementById("imgIdentificationResidence");
      document2.style.display = "none";
      document2.style.width = "0px";
      document2.style.height = "0px";

      var document3 = document.getElementById("imgIdentificationIneIfe");
      document3.style.display = "none";
      document3.style.width = "0px";
      document3.style.height = "0px";

      var document4 = document.getElementById("imgIdentificationPassport");
      document4.style.display = "none";
      document4.style.width = "0px";
      document4.style.height = "0px";

      switch (this.typeIdentification) {
        case "CÈDULA PROFESIONAL":
          document1.style.display = "block";
          document1.style.width = "250px";
          document1.style.height = "50px";
          document5.style.marginTop = "140px";
          break;
        case "CÈDULA DE RESIDENCIA":
          document2.style.display = "block";
          document2.style.width = "250px";
          document2.style.height = "50px";
          document5.style.marginTop = "140px";
          break;
        case "INE/IFE":
          document3.style.display = "block";
          document3.style.width = "250px";
          document3.style.height = "50px";
          document5.style.marginTop = "140px";
          break;
        case "PASAPORTE":
          document4.style.display = "block";
          document4.style.width = "250px";
          document4.style.height = "50px";
          document5.style.marginTop = "140px";
          break;
        default:
      }
    },
    matiButton() {
      if(document.getElementById("btnMati") != null){
        if(this.mati_identity_id == null || this.mati_identity_id == "")
        {
          document
          .getElementById("btnMati")
          .addEventListener("mati:userFinishedSdk", ({detail}) => {
            localStorage.setItem("mati_identity_id", detail.identityId);
            this.mati_identity_id = localStorage.mati_identity_id;
            console.log("finisheduserFinishedSdk META", detail);
            console.log("mati_identity_id: META", this.mati_identity_id);
          });
        }
      }
      if(this.count == 0 && this.mati_identity_id != null && this.mati_identity_id != ""){
        this.getStatusVerificationMati();
        this.count++;
      }
      return `<mati-button id="btnMati" clientid="${this.matiClientId}" metadata='{"business_acronym":"${this.business}", "mati_verification_type":"${this.mati_verification_table_type}", "mati_verification_id":"${this.admission_id}"}' flowId="${this.matiFlowid}" />`
    },
    getFaceMatch(data) {
      for (let index = 0; index < data.length; index++) {
        if (data[index].id == "facematch") {
          if (data[index].data.score % 1 == 0) {
            return data[index].data.score;
          } else {
            return parseFloat(
                Math.round(data[index].data.score * 100) / 100
            ).toFixed(2);
          }
        }
      }
      return 0;
    },
    getErrorsIdentityMati(data, clickButtonMati) {
      var message =
          `<p style="font-weight:bold;">En la validación de identidad los siguientes datos no pudieron ser validados:</p> `;
      var index = [];
      var curp = null;
      var rfc = null;
      var alterationDetected = null;
      var templateMatching = null;
      var faceMatch = null;
      var ageCheck = null;
      var documentReading = null;
      var watchLists = null;
      var documentExpired = false;
      var invalidDocument = false;
      var documentExpiredArray = [];
      var validationMatiAttempts = JSON.parse(sessionStorage.getItem("ValidationMatiAttempts_"+this.user_id));

      curp = data.response.result.documents[0].steps.filter(
          ({id}) => id === "mexican-curp-validation"
      )[0].error;
      rfc = data.response.result.documents[0].steps.filter(
          ({id}) => id === "mexican-rfc-validation"
      )[0].error;
      alterationDetected = data.response.result.documents[0].steps.filter(
          ({id}) => id === "alteration-detection"
      )[0].error;
      templateMatching = data.response.result.documents[0].steps.filter(
          ({id}) => id === "template-matching"
      )[0].error;
      faceMatch = data.response.result.documents[0].steps.filter(
          ({id}) => id === "facematch"
      )[0].error;
      documentReading = data.response.result.documents[0].steps.filter(
          ({id}) => id === "document-reading"
      )[0].error;
      watchLists = data.response.result.documents[0].steps.filter(
          ({id}) => id === "watchlists"
      )[0].error;

      if (
          data.response.result.documents[0].type.replace(/['"]+/g, "") ==
          "passport"
      ) {
        if (
            data.response.result.computed.isDocumentExpired.data.passport
        ) {
          documentExpired = true;
        }
      } else if (
          data.response.result.documents[0].type.replace(/['"]+/g, "") ==
          "national-id"
      ) {
        for (var x in data.response.result.computed.isDocumentExpired
            .data) {
          if (x == "national-id") {
            index.push(x);
          }
        }

        index.sort(function (a, b) {
          return a == b ? 0 : a > b ? 1 : -1;
        });

        if (
            data.response.result.computed.isDocumentExpired.data[index[0]]
        ) {
          documentExpired = true;
        }
        
        ageCheck = data.response.result.documents[0].steps.filter(
            ({id}) => id === "age-check"
        )[0].error;
      }

      if (!documentExpired) {
        if (
            ageCheck != null ||
            faceMatch != null
        ) {
          if (ageCheck != null) {
            documentExpiredArray.push("EDAD");
          }
          if (faceMatch != null) {
            documentExpiredArray.push("ROSTRO");
          }
        } else {
          if (alterationDetected != null) {
            message =
                `<p style="font-weight:bold;">En la validación de identidad se detectó una alteración en el documento. Favor de verificarse de nuevo.</p>`;
          }
          if (templateMatching != null) {
            message =
                `<p style="font-weight:bold;">La verificación cargada no corresponde al tipo de documento seleccionado.</p>`;
          }

          if (documentReading != null) {
            message =
                `<p style="font-weight:bold;">En la validación de identidad el documento no pudo ser leído. Favor de verificarse de nuevo.</p>`;
          }
          if (watchLists != null) {
            message = `<p style="font-weight:bold;">Hemos identificado que usted está en la lista de personas expuestas políticamente. Favor de contactarse con un asesor.</p>`;
            invalidDocument = true;  
          }
        }
      } else {
        message =
            `<p style="font-weight:bold;">En la validación de identidad se detectó caducidad de documentos. Favor de verificarse de nuevo con un documento vigente.</p>`;
      }

      message += `<span style="color:red;font-weight:bold;">${documentExpiredArray.join(", ")} </span>`;

      if (message == "Los siguientes datos no pudieron ser validados: ") {
        message =`<p style="font-weight:bold;">Favor de verificarse de nuevo, los documentos cargados anteriormente no pudieron ser validados.</p>`;
      }
      
      if (clickButtonMati) {
        if (invalidDocument) {
          validationMatiAttempts++;
          if (validationMatiAttempts >= 3) {
            message += `<br/><br/> <p style="font-weight:bold;">El proveedor de validación de identidad está presentando problemas, favor de intentar validarse de nuevo en una hora.</p>`;
          }  
        }
      }
      
      if (message != "" && validationMatiAttempts < 3) {
        message += `<br/><br/> <p style="font-weight:bold;">Favor de realizar la validación de identidad de nuevo.</p>`;
      }

      validationMatiAttempts = validationMatiAttempts >= 3 ? 0: validationMatiAttempts;
      sessionStorage.setItem("ValidationMatiAttempts_"+this.user_id, JSON.parse(validationMatiAttempts));

      return message;
    },
    removeAccents(str) {
      return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
    },
    verificationResult(responseVerificationMati) {
      var list_errors = [];
      var fullname = (
        this.removeAccents(this.firstName) +
        this.removeAccents(this.lastName) +
        this.removeAccents(this.paternal) +
        this.removeAccents(this.maternal)
      ).toLowerCase();
      var birthday = `${responseVerificationMati.dateOfBirth.value} ${"00:00:00"}`;

      var fullnameDocument = this.removeAccents(responseVerificationMati.fullName.value).toLowerCase();
      console.log("fullnameDocument: ",fullnameDocument);
      console.log("fullname: ",fullname);

      // if (
      //     fullname.replaceAll(" ", "") != fullnameDocument.replaceAll(" ", "")
      // ) {
      //   list_errors.push("NOMBRE");
      // }

      var gender = this.gender == "FEMENINO" ? "F" : "M";
      // if (gender != responseVerificationMati.sex.value) {
      //   list_errors.push("SEXO");
      // }

      // if (this.rfc.substr(0, 10).toLowerCase() != responseVerificationMati.curp.value.substr(0, 10).toLowerCase()) {
      //   list_errors.push("RFC");
      // }

      moment.locale("es");
      let dateFormat = moment( birthday).format("DD-MM-YYYY");
      birthday = dateFormat;
      if (this.birthday != birthday) {
        list_errors.push("FECHA DE NACIMIENTO");
      }
      return list_errors;
    },
    async loadInfo() {
      this.isLoading = true;
      await this.validityRFC();
      await this.validateCP();
      await this.showImageTypeIdentication();
      this.getStates();
      this.isLoading = false;
    },
    async searchPersonalData() {
      var response = this.getJsonFromLocalStorageBy(`admissionUser${this.user_id}`);
      
      if (Object.entries(response).length != 0) {
        await this.getDataAdmissionUser();
      }else{
        await this.getAdmissionRequest();
        await this.getDataAdmissionUser(true);
      }
    },
    async getDataAdmissionUser(callGetAdmissionRequest = false){
      var response = this.getJsonFromLocalStorageBy(`admissionUser${this.user_id}`);
      
      if (Object.entries(response).length != 0) {
        this.setPersonalInfoToLocalStorage("geolocalizacion", response.data.response.admission_request.admission_information.geolocation);

        this.rfc = response.data.response.admission_request.admission_information.rfc
        this.paternal = response.data.response.admission_request.admission_information.paternal_name
        this.maternal = response.data.response.admission_request.admission_information.maternal_name
        this.lastName = response.data.response.admission_request.admission_information.middle_name
        this.firstName = response.data.response.admission_request.admission_information.name
        this.gender = response.data.response.admission_request.admission_information.gender.toUpperCase();

        this.admission_information = response.data.response.admission_request.admission_information;
        this.status_admission="info_personal_complete";
        this.postalCode = response.data.response.admission_request.admission_information.postal_code;
        this.validateCP();
        this.validityRFC();
        this.gender = response.data.response.admission_request.admission_information.gender.toUpperCase();
        this.stateNac = response.data.response.admission_request.admission_information.state_birth;
        this.cityNac = response.data.response.admission_request.admission_information.city_birth;
        this.municipalityNac = response.data.response.admission_request.admission_information.municipality_birth;
        this.countryNac = response.data.response.admission_request.admission_information.country_birth == "" ? "México" : response.data.response.admission_request.admission_information.country_birth;
        this.nacionalityNac = response.data.response.admission_request.admission_information.nationality == "" ? "Mexicana" : response.data.response.admission_request.admission_information.nationality;
        this.street = response.data.response.admission_request.admission_information.street;
        this.between_street_one = response.data.response.admission_request.admission_information.between_street_one;
        this.between_street_two = response.data.response.admission_request.admission_information.between_street_two;
        this.numberExt = response.data.response.admission_request.admission_information.ext_number;
        this.numberInt = response.data.response.admission_request.admission_information.int_number;
        this.colony = response.data.response.admission_request.admission_information.suburb;
        let contact_info = response.data.response.admission_request.admission_information.contact_info_attributes;
       
        for (let obj in contact_info) {
          if (contact_info[obj].contact_type == "celular") {
            this.cellphone = mask(contact_info[obj].value, '### ###-####');
          }
          if (
              contact_info[obj].contact_type == "telefono particular"
          ) {
            this.phone = mask(contact_info[obj].value, '### ###-####');
          }
          if (contact_info[obj].contact_type == "correo") {
            this.email = contact_info[obj].value;
          }
        }



        this.admission_registration_date = response.data.response.admission_request.created_at
        console.log("getAdmissionRequest: Solicitud Ya registrada");
        this.admission_id = response.data.response.admission_request.id;
        this.status_admission = response.data.response.admission_request.status;
        this.isCellphoneVerified = response.data.response.admission_request.cell_phone_verified;
        if(callGetAdmissionRequest == false){
          let isValid = this.verifyStatusAdmission(response);
          if(!isValid){
            return;
          }
        }
        
      }
    },
    setToLocalStorageValidationMatiAttempts(item, value) {
      let ValidationMatiAttempts = JSON.parse(sessionStorage.getItem("ValidationMatiAttempts_"+this.user_id));

      if (ValidationMatiAttempts == null) {
        sessionStorage.setItem("ValidationMatiAttempts_"+this.user_id, JSON.parse(0));
      }
    },
    async validateProcess(){
      
      let statusNotToContinue = true;
      
      let token = sessionStorage.getItem("login");
      let person_id = this.personId;
      return await getAdmissionRequestOrCreate(
          token,
          person_id
      ).then((response) => {
        let admissionStatus = response.data.response.admission_request.status;
        if (admissionStatus == "pendiente_de_revision" || admissionStatus == "en_revision") {
          Swal.fire({
            title: "Aviso",
            text:
                "La solicitud se encuentra en proceso de revisión, pronto será contactado por un asesor.",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });

          this.$router.push({path:"/cuenta/principal"});
          statusNotToContinue = false;
        }

        if (admissionStatus == "aceptada") {
          Swal.fire({
            title: "Aviso",
            text:
                "La solicitud ingresada ya ha sido aceptada.",
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });

          this.$router.push({path:"/cuenta/principal"});
          statusNotToContinue = false;
        }

        return statusNotToContinue;
      });
    },
    async getAdmissionRequest() {
      let token = sessionStorage.getItem("login");
      let person_id = this.personId;
      await getAdmissionRequestOrCreate( //Se consultan las solicitudes
          token,
          person_id
      )
          .then((response) => {
            this.setPersonalInfoToLocalStorage(`admissionUser${this.user_id}`, response);
            this.setPersonalInfoToLocalStorage("geolocalizacion", response.data.response.admission_request.admission_information.geolocation);
            this.jsonResponse = response;
            if (response.data.response.admission_request != null) //Si ya esta registrada una solicitud
            {
              console.log("getAdmissionRequest: Solicitud Ya registrada");
              this.admission_id = response.data.response.admission_request.id; //se obtiene el id de la solicitud
              this.status_admission = response.data.response.admission_request.status;
              this.isCellphoneVerified = response.data.response.admission_request.cell_phone_verified;
              let isValid = this.verifyStatusAdmission(response);//Se verifica el estatus de la solicitud

              if(!isValid){
                return;
              }

              this.admission_registration_date = response.data.response.admission_request.created_at
            }
            else {
              //sino hay alguna solicitud registrada, se registra con el json vacio (que se importa)
              console.log("getAdmissionRequest: Solicitud no registrada");
              this.saveRequest(jsonData).then((response)=> {
                this.admission_registration_date = response.data.response.created_at
                this.showMessageGeolocation();
              });
              //mostrar boton mati y ocultar inputs
              this.user_is_validated = false;
              this.continuedRegistration = false;
            }
          })
          .catch((error) => {
            var message = error.response.data.errors[0]
            if(error.response.data.errors[0] == "plazo de solicitud rechazada vigente"){
              message = error.response.data.response.message
            }
            Swal.fire({
              title: "Aviso",
              customClass: {
                container: 'my-swal'
              },
              text: message,
              icon: "info",
              confirmButtonColor: '#FEB72B',
            }).then((result) => {
              if (result.isConfirmed) {
                this.$router.push({path:"/cuenta/principal"});
              }
            })
          });
    },
    termsGeolocation(terms, confirmation)  {
      this.allowGeolocation = terms;
      if (confirmation) {
        this.showModalTermsGeolocationConfirmation = false;
        if (!terms) {
          // window.location.href = "/cuenta/principal";
          this.$router.push({path:"/cuenta/principal"});
          return;
        } 
        this.geoLocationMaps();
        this.showRequestExpirationTimeNotice();
      } else {
        this.showModalTermsGeolocation = false;
      
        if (!terms) {
          this.showModalTermsGeolocationConfirmation = true;
          return;
        }
        this.geoLocationMaps();
        this.showRequestExpirationTimeNotice();
      }
    },
    showRequestExpirationTimeNotice(){
      var text = "<p style='font-size:14px'>Estimado(a) " + this.fullName + " gracias por su interés en FONCABSA. Le informamos que a partir de esta fecha "+ this.formatDate(this.admission_registration_date) +" tendrá 15 días para concluir su registro. En caso de que  exceda ese tiempo, tendrá que registrar nuevamente su información utilizando su usuario y contraseña.</p>"
      Swal.fire({
        html: text,
        confirmButtonColor: '#FEB72B',
      });
    },
    showMessageGeolocation() {
      this.showModalTermsGeolocation = true;
    },
    async verifyStatusAdmission(response) {

      let statusNotToContinue = false;
      this.admission_status = response.data.response.admission_request.status;  //se obtiene el estatus de la solicitud

      if(this.admission_status != "identidad_no_verificada"){ 
        this.geoLocationMaps();
      }

      //Se verifica el estatus de la solicitud
      if (this.admission_status == "pendiente_de_revision" || this.admission_status == "en_revision") {
        await Swal.fire({
          title: "Aviso",
          text:
              "La solicitud se encuentra en proceso de revisión, pronto será contactado por un asesor.",
          icon: "warning",
          confirmButtonColor: '#FEB72B',
        });

        this.$router.push({path:"/cuenta/principal"});
        statusNotToContinue = true;
      }

      if (this.admission_status == "aceptada") {
        await Swal.fire({
          title: "Aviso",
          text:
              "La solicitud ingresada ya ha sido aceptada.",
          icon: "warning",
          confirmButtonColor: '#FEB72B',
        });
        // window.location.href = "/cuenta/principal";
        this.$router.push({path:"/cuenta/principal"});
        statusNotToContinue = true;
      }

      if(statusNotToContinue){
        return statusNotToContinue;
      }

      //se consulta si la solicitud ya tiene una verificación y se muestra
      await this.getDataVerificationByProcess();
    },
    async saveRequest(jsonData) {
      this.isLoading = true;
      jsonData.token_auth = sessionStorage.getItem("login");
      return await saveRequest(
          jsonData
      )
          .then((response) => {
            this.setPersonalInfoToLocalStorage("geolocalizacion", `${this.municipality != "N/A" ? this.municipality + ",": ""}${this.city != "N/A" ? " " + this.city + ", " : " "}${this.state}`)
            this.setPersonalInfoToLocalStorage(`admissionUser${this.user_id}`, response);
            this.admission_id = response.data.response.admission_request.id; //se obtiene el id de la solicitud
            this.status_admission = response.data.response.admission_request.status;
            this.admission_information = response.data.response.admission_request.admission_information;
          })
          .catch((error) => {
            console.log(
                "Se presento un error al guardar la información personal: ",
                error
            );
            Swal.fire({
              title: "Aviso",
              text:
                  "Se presentó un error. No fue posible registrar los datos de la solicitud.",
              icon: "error",
              confirmButtonColor: '#FEB72B',
            });
          }).finally(() => {
            this.isLoading = false
          })
    },
    async getStatusVerificationMati() {//se consulta el estatus de verificación
      this.isLoading = true;
      //ya se hizo el proceso de la verificación(subir archivos, grabar video...)
      let mati_verification_table_type = "admission_requests";
      let mati_verification_table_id = this.admission_id;
      await getStatusVerificationMati( //se consulta estatus de la verificación
          mati_verification_table_type,
          mati_verification_table_id
      )
          .then(({data}) => {
            var dataResponse = data;
            if (dataResponse.response.result.eventName == "verification_completed") {
              this.registerExist = true;
              this.data_verification_id = dataResponse.response.data_verification_id;
              //si esta verificado se consultan los datos y Se muestran los datos de verificación
              this.clickButtonMati = true;
              this.getDataVerificationMati();
              
            } else {
              this.isLoading = false;
              this.registerExist = false;
            }
          })
          .catch((error) => {
            this.registerExist = false;
            console.log("Se presentó un error al obtener el estatus de la verificación: ", error);
            Swal.fire({
              title: "Aviso",
              text:
                  "Se presentó un error en el proceso de verificación.",
              icon: "error",
              confirmButtonColor: '#FEB72B',
            });
          }).finally(() => {
            this.isLoading = false;
          })
    },
    async getDataVerificationMati() {
      this.isLoading = true;
      let data_verification_id = this.data_verification_id;

      await getDataVerificationMati(
        data_verification_id
      )
          .then(({data}) => {
            // console.log("geolocalizaion: ",data.response.result.steps[1].data.city);
            // this.geolocation = data.response.result.steps[1].data.city + ", "+data.response.result.steps[1].data.region;
            // this.setPersonalInfoToLocalStorage("geolocalizacion",data.response.result.steps[1].data.city + ", "+data.response.result.steps[1].data.region)
            //se muestra la info de la verificación
            this.buildIdentityInfo(data);
            if (this.postalCode == "" && this.continuedRegistration) {
              this.getAddressFromMati(data);
            }
            
            this.registerExist = true;
          })
          .catch((error) => {
            
            this.registerExist = false;
            console.log("Se presentó un error al consultar los datos de la verificación: ", error);
            Swal.fire({
              title: "Aviso",
              text:
                  "Se presentó un error al consultar los datos de la verificación.",
              icon: "error",
              confirmButtonColor: '#FEB72B',
            });
          })
          .finally(() => {
            this.isLoading = false;
          })
    },
    geoLocationMaps() {
      if (!navigator.geolocation){
        self.setPersonalInfoToLocalStorage("geolocalizacion", "Su navegador no admite la geolocalización");
        return;
      }

      let self = this;
      function success(position) {
        var latitude  = position.coords.latitude;
        var longitude = position.coords.longitude;

        var url = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude +'&key=AIzaSyAyB-PIpbZwaqnrYOd9Bz9eQMWGIJuTkcQ';

        var json;
        var Http = new XMLHttpRequest();
        Http.open('POST', url);
        Http.send();

        Http.onreadystatechange = (e) => {
            json = JSON.parse(Http.responseText);
            if (json.status == "REQUEST_DENIED") {
              self.setPersonalInfoToLocalStorage("geolocalizacion", "No se puede obtener su ubicación");
              return;
            }
            
            let locality = json.results[0].address_components.filter(({types})=>types.includes("locality"))[0].long_name;
            let state = json.results[0].address_components.filter(({types})=>types.includes("administrative_area_level_1"))[0].long_name;
            let country = json.results[0].address_components.filter(({types})=>types.includes("country"))[0].long_name;
            let location = locality+", "+state+", "+country;
            console.log("location: "+location);
            self.setPersonalInfoToLocalStorage("geolocalizacion", location);
        }
      };

      function error() {
        self.setPersonalInfoToLocalStorage("geolocalizacion", "No se puede obtener su ubicación");
      };

      navigator.geolocation.getCurrentPosition(success, error);
    },
    getLocation()
    {
      var location = "";
      var geolocalizacion = this.getJsonFromLocalStorageBy("geolocalizacion");
      console.log("asignar a json location: "+geolocalizacion);
      if (geolocalizacion == "" || geolocalizacion == "Su navegador no admite la geolocalización" || geolocalizacion == "No se puede obtener su ubicación") {
        location = `${this.municipality != "N/A" ? this.municipality + ", ": ""}${this.city != "N/A" ? " " + this.city + ", " : " "}${this.state}`;
        this.setPersonalInfoToLocalStorage("geolocalizacion", location)
      }else{
        location = geolocalizacion;
      }
      return location;
    },
    async getDataVerificationByProcess() {
      this.isLoading = true;
      let admission_id = this.admission_id;
      await getDataVerificationByProcess(
          admission_id
      )
          .then((dataResponse) => {
            this.user_is_validated = true;
            this.allowGeolocation = true;
            this.continuedRegistration = true;
            this.data_verification_id = dataResponse.data.response.result.data_verification_id;
            //se consulta toda la información de la verificación
            this.getDataVerificationMati();
            
          })
          .catch((error) => {
            this.user_is_validated = false;
            this.continuedRegistration = false;
            this.showMessageGeolocation();
            /*Swal.fire({
              title: "Aviso",
              text:
                  "Se presentó un error al consultar la información de de verificación.",
              icon: "warning",

            });*/
          }).finally(() => {
            this.isLoading = false
          })
    },
    async buildIdentityInfo(data) {
      
      this.responseVerificationMati = data;
      this.matiStatusVerification = data.response.result.identity.status;
      if (
          this.matiStatusVerification == "reviewNeeded" ||
          this.matiStatusVerification == "rejected"
      ) {
        //var errors = this.getErrorsIdentityMati(data, this.clickButtonMati);
        var errors = "Se encontraron los siguientes detalles durante la verificación, favor de intentarlo de nuevo<br><br>"

        data.response.errors_of_verification.map((va) => errors += "• "+va+"<br>")
        console.log(errors)
        
        if (errors != "") {
          Swal.fire({
            title: "Aviso",
            html: errors,
            icon: "warning",
            confirmButtonColor: '#FEB72B',
          });
          this.user_is_validated=false;
          this.continuedRegistration=false;
          this.count=0;
          this.mati_identity_id="";
        }
      }
      if (this.matiStatusVerification == "verified") {
        this.user_is_validated = true;
        this.continuedRegistration = true;

        console.log(this.status_admission)
        if (this.status_admission == "identidad_no_verificada")
        {
          var infoJson = this.buildJson("identidad_verificada");
          await this.saveRequest(infoJson);
        
          Swal.fire({
            title: "Aviso",
            text: "La validación de identidad se realizó correctamente",
            icon: "success",
            confirmButtonColor: '#FEB72B',
          });

        }
      }

      var documentType = "";
      try {
        documentType = JSON.stringify(
            data.response.result.documents[0].type
        ).replace(/['"]+/g, "");
      } catch {
      }
      this.percentageVerified = this.getFaceMatch(
          data.response.result.documents[0].steps
      );
      this.documentType = documentsType[documentType];
      this.typeIdentification = documentsType[documentType];
      this.showImageTypeIdentication();

      if (documentType == "passport") {
        this.isNumberIdentification = false;
        this.matiDocumentNumber = JSON.stringify(
            data.response.result.documents[0].fields.documentNumber
                .value
        ).replace(/['"]+/g, "");
      } else {
        this.isNumberIdentification = true;
        this.numberIdentification = JSON.stringify(
            data.response.result.documents[0].fields.ocrNumber.value
        ).replace(/['"]+/g, "");
        this.curp =JSON.stringify(
            data.response.result.documents[0].fields.curp.value
        ).replace(/['"]+/g, "");

        /*if (JSON.stringify(
            data.response.result.documents[0].fields.sex.value
        ).replace(/['"]+/g, "") == "M") {
          this.gender = "MASCULINO"
        } else if (JSON.stringify(
            data.response.result.documents[0].fields.sex.value
        ).replace(/['"]+/g, "") == "F"){
          this.gender = "FEMENINO"
        }*/

      }
    },
    getAddressFromMati(data){
      var addressId = data.response.result.documents[0].fields.address.value.split(" ");

      this.street = this.matiObject.getStreetAddress(addressId)
      this.numberExt = this.matiObject.getNumberAddress(addressId)
      this.postalCode = this.matiObject.getPostalCodeAddress(addressId)
      this.validateCP();

    },
    validateVerificationResult(list_errors) {
      if (list_errors.length > 0) {
        Swal.fire({
          title: "Aviso",
          html: `<p>Los siguientes datos no corresponden a su <span style="font-weight: bold;">${
              this.documentType
          }</span> proporcionado en la validación de identidad: <br/>
                            <span style="font-weight: bold; color:red">${list_errors.join(
              ", "
          )}</span>
                            ${
              list_errors.includes("RFC")
                  ? "<br/><br/>Si el RFC fue capturado erroneamente favor de comunicarse con un asesor."
                  : ""
          }</p>`,
          // text: `Los siguientes datos no corresponden al documento proporcionado en la validación de identidad: ${list_errors.join(", ")}
          // Si sus datos fueron capturados erroneamente favor de comunicarse con un asesor. `,
          icon: "warning",
          confirmButtonColor: '#FEB72B',
        });
        return false;
      }
      return true;
    },
    validateInfoUser() {
      if(this.postalCode.toString().length != 5){        
        this.showMessage(
          "Aviso",
          "Favor de capturar un código postal valido"
        );
        return false;
      }

      if(this.street.toString().length < 4){        
        this.showMessage(
          "Aviso",
          "La calle debe contener mínimo 4 caracteres"
        );
        return false;
      }

      if(this.paternal=="" && this.maternal == ""){        
        this.showMessage(
          "Aviso",
          "Favor de capturar por lo menos un apellido"
        );
        return false;
      }

      if (this.phone != "") {
        console.log("phone: ",this.phone.length);
        if (this.phone.length != 12) {
          this.showMessage(
              "Aviso",
              "El Teléfono particular debe contener 10 dígitos"
          );
          return false;
        }
      }

      if (this.cellphone.length != 12) {
        this.showMessage(
            "Aviso",
            "El Teléfono celular debe contener 10 dígitos"
        );
        return false;
      }

      if (this.postalCode.length < 5) {
        this.showMessage("Aviso", "El Código Postal debe contener 5 dígitos");
        return false;
      }
      return true;
    },
    showMessage(title, message, icon = "warning") {
      Swal.fire({
        title: title,
        text: message,
        icon: icon,
        confirmButtonColor: '#FEB72B',
      });
    },
    async Next(e) {
      e.preventDefault();

      let response_validate_phone = this.validate_phone();

      if(response_validate_phone)
        return;

      this.genderStatus = this.validateGender();
      if(!this.genderStatus){
        var element = document.querySelector("#personalInformationSection");

        element.scrollIntoView();
        return;
      }

      if(!this.isCellphoneVerified){
        this.codeCellphone = "";
        this.validateCellphone();
        return;
      }
      this.isLoading = true;
      var list_errors = this.verificationResult(
          this.responseVerificationMati.response.result.documents[0].steps.filter(b => b.id === "document-reading")[0].data
      );
      if (!this.validateVerificationResult(list_errors)) {
        this.isLoading = false;
        return;
      }
      if (!this.validateInfoUser()) {
        this.isLoading = false;
        return;
      }

      var infoJson = this.buildJson();

      infoJson.admission_request_params.admission_information.contact_info_attributes = this.insertContactInfo();
      
      //Se actualiza el registro de solicitud
      if(this.admissionStatusIsValidToSave(this.admission_status))
      {
        await this.saveRequest(infoJson);
      }
      this.admissionRequestObject.getAndSaveIdentification(sessionStorage.getItem("login"), this.admission_id);
      this.isLoading = false;
      // window.location.:href="$router.resolve('/cuenta/registro-datos-personales-dos').href"
      this.$router.push({path:"/cuenta/registro-datos-personales-dos"});
    },
    admissionStatusIsValidToSave( status ) {
      const validStatuses = [
        "info_personal_incompleta",
        "identidad_no_verificada",
        "identidad_validada"
      ];

      return (validStatuses.find(value => value == status))? true: false;
    },
    buildJson(_admission_status = "info_personal_incomplete") {
      var json = this.getJsonFromLocalStorageBy('admissionUser'+this.user_id);
      if(!json){
        json.data.response.admission_request.residence_start = "";
        json.data.response.admission_request.residence_status = "";
        json.data.response.admission_request.education_level = "";

        json.data.response.admission_request.adress_attributes.residence_start = "";
        json.data.response.admission_request.adress_attributes.residence_status = "";

        json.data.response.admission_request.marital_status = "";
        json.data.response.admission_request.regime = "";

        json.data.response.admission_request.latitude = "";
        json.data.response.admission_request.longitude = "";

        json.data.response.admission_request.adress_attributes.latitude = "";
        json.data.response.admission_request.adress_attributes.longitude = "";
      }
      

      json.data.response.admission_request.admission_information.rfc = this.addUpperCase(this.rfc);
      json.data.response.admission_request.admission_information.paternal_name = this.addUpperCase(this.paternal).trim();
      json.data.response.admission_request.admission_information.maternal_name = this.addUpperCase(this.maternal).trim();
      json.data.response.admission_request.admission_information.name = this.addUpperCase(this.firstName).trim();
      json.data.response.admission_request.admission_information.middle_name = this.lastName ? this.addUpperCase(this.lastName).trim() : "";
      json.data.response.admission_request.admission_information.gender = this.gender.toLowerCase();
      json.data.response.admission_request.admission_information.curp = this.addUpperCase(this.curp);
      json.data.response.admission_request.admission_information.birthday = this.orderDateByYearMonthDay(this.birthday,"-");
      json.data.response.admission_request.admission_information.city_birth = this.addUpperCase(this.cityNac);
      json.data.response.admission_request.admission_information.state_birth = this.stateNac;
      json.data.response.admission_request.admission_information.municipality_birth = this.addUpperCase(this.municipalityNac);
      json.data.response.admission_request.admission_information.country_birth = this.addUpperCase(this.countryNac);
      json.data.response.admission_request.admission_information.nationality = this.addUpperCase(this.nacionalityNac);
      json.data.response.admission_request.admission_information.identification_type = this.typeIdentification;
      json.data.response.admission_request.admission_information.identification_number = this.addUpperCase(this.numberIdentification) == "" ? this.addUpperCase(this.matiDocumentNumber) : this.addUpperCase(this.numberIdentification);
      
      json.data.response.admission_request.admission_information.street = this.addUpperCase(this.street).trim();
      json.data.response.admission_request.admission_information.between_street_one = this.addUpperCase(this.between_street_one).trim();
      json.data.response.admission_request.admission_information.between_street_two = this.addUpperCase(this.between_street_two).trim();
      json.data.response.admission_request.admission_information.ext_number = this.numberExt;
      json.data.response.admission_request.admission_information.int_number = this.numberInt.trim();
      json.data.response.admission_request.admission_information.suburb = this.colony;
      json.data.response.admission_request.admission_information.postal_code = this.postalCode;
      json.data.response.admission_request.admission_information.municipality = this.municipality;
      json.data.response.admission_request.admission_information.city = this.city;
      json.data.response.admission_request.admission_information.state = this.state;
      json.data.response.admission_request.admission_information.country = "MÉXICO";
      json.data.response.admission_request.admission_information.client_classification = this.clientClassification;
      json.data.response.admission_request.admission_information.geolocation = this.getLocation();

      
      json.data.response.admission_request.admission_information.status = "activo";
      json.data.response.admission_request.admission_information.adress_attributes.street = this.addUpperCase(this.street).trim();
      json.data.response.admission_request.admission_information.adress_attributes.between_street_one = this.addUpperCase(this.between_street_one).trim();
      json.data.response.admission_request.admission_information.adress_attributes.between_street_two = this.addUpperCase(this.between_street_two).trim();
      json.data.response.admission_request.admission_information.adress_attributes.ext_number = this.numberExt;
      json.data.response.admission_request.admission_information.adress_attributes.int_number = this.numberInt.trim();
      json.data.response.admission_request.admission_information.adress_attributes.suburb = this.colony;
      json.data.response.admission_request.admission_information.adress_attributes.postal_code = this.postalCode;
      json.data.response.admission_request.admission_information.adress_attributes.city = this.city;
      json.data.response.admission_request.admission_information.adress_attributes.state = this.state;
      json.data.response.admission_request.admission_information.adress_attributes.country = "MÉXICO";
      json.data.response.admission_request.admission_information.adress_attributes.status = "activo";
      json.data.response.admission_request.admission_information.adress_attributes.municipality = this.municipality;

      this.setPersonalInfoToLocalStorage('admissionUser'+this.user_id, json)

      return {
        token_auth: sessionStorage.getItem("login"),
        admission_request_id: this.admission_id,
        user_id: this.user_id,
        change_for: _admission_status,
        admission_request_params: {
          admission_information: json.data.response.admission_request.admission_information,
          status: "",
          acepted_date: ""
        },
      };
    },
    orderDateByDayMonthYear(date, typeSplit){
      var elemtsOfDate = date.split(typeSplit)
      var year = elemtsOfDate[0]
      var month = elemtsOfDate[1]
      var day = elemtsOfDate[2]
      return day+"-"+month+"-"+year
    },
    orderDateByYearMonthDay(date, typeSplit){
      var elemtsOfDate = date.split(typeSplit)
      var day = elemtsOfDate[0]
      var month = elemtsOfDate[1]
      var year = elemtsOfDate[2]
      return year+"-"+month+"-"+day
    },
    checkAdmissionRequestRejected(){
      var admisisonRequestId = this.getJsonFromLocalStorageBy(`admissionRequestId`);
      var admissionStorage = this.getJsonFromLocalStorageBy(`admissionUser${this.user_id}`);

      if(Object.entries(admissionStorage).length != 0 && admisisonRequestId != admissionStorage.data.response.admission_request.id){
        sessionStorage.removeItem(`admissionUser${this.user_id}`)
        console.log("admissionUser eliminado")  
      }
    }
  },
};
</script>

<style>
input, h1, h2, h3, h4, h5, h6, label, p, b {
  font-family: Roboto;
}
button, input, optgroup, select, textarea {
  font-size: initial;
}
.center {
  padding: 00px 0;
  text-align: center;
}

@media (min-width: 766px) {
  .collapse.dont-collapse-sm {
    display: block;
    height: auto !important;
    visibility: visible;
  }

  .border {
    border-right: 1px dashed #333;
    border-top: 1px dashed #ffffff;
    border-left: 1px dashed #ffffff;
    border-bottom: 1px dashed #ffffff;
  }
}

@media (max-width: 766px) {
  .border {
    margin-left: 9px;
    margin-right: -15px;
    border-right: 1px dashed #ffffff;
    border-top: 1px dashed #ffffff;
    border-left: 1px dashed #ffffff;
    border-bottom: 1px dashed #ffffff;
  }
}

#button_popups {
  border-top-left-radius: 7px;
  border-top-right-radius: 7px;
  border-bottom-left-radius: 7px;
  border-bottom-right-radius: 7px;
  background-color: #feb72b;
  color: #fff;
  font-weight:bold;
  width: 250px;
  height: 40px;
  padding-top: 0%;
  font-size:16px;
}

@media (max-width: 500px) {
  #button_popups {
    height: 50px;
  }
}

/*Tooltip*/

.tooltips {
  position: relative;
  /* display: inline-block; */
  opacity: 1;
}

.tooltips .tooltipstext {
  visibility: hidden;
  width: 160px;
  background-color: #690B2F;
  font-family: Roboto;
  font-weight: 300;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  top: -8px;
  right: 105%;
}

.tooltips .tooltipstext::after {
  content: " ";
  position: absolute;
  top: 50%;
  left: 100%;
  /* To the right of the tooltip */
  margin-top: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent transparent #690B2F;
}

.tooltips input:focus + .tooltipstext {
  visibility: visible;
}

@media only screen and (max-width: 767px) {
  .tooltips .tooltipstext {
    visibility: hidden;
    width: 210px;
    background-color: #690B2F;
    font-size: 15px;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 0;
    padding-left: 5px;
    padding-right: 5px;
    position: absolute;
    top: -100px;
    left: 30%;
    height: 100px;
    margin-left: -60px;
  }
  .tooltips .tooltipstext::after {
    content: "";
    position: absolute;
    top: 104%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #690B2F transparent transparent transparent;
    }
}

.verifyButtonWithoutBackground {
    background-color: #fff; /* Green */
    border: 1px solid #FFCC00;
    border-radius: 5px;
    color: #FFCC00;
    padding: 1px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    font-family:Roboto;
    widows: 10px;
    height: 30px;
    cursor: pointer;
}
.verifyButton {
    border-color: 1px solid #FFCC00;
    background-color: #FFCC00; /* Green */
    border: none;
    border-radius: 5px;
    color: white;
    padding: 1px 10px;
    text-align: center;
    text-decoration: none;
    display: inline-block;
    font-size: 14px;
    font-family:Roboto;
    widows: 10px;
    height: 30px;
    cursor: pointer;
}
.verifyButton:hover {
  background-color: #FFDB4B;
}
.my-swal {
  display: -webkit-box;
  display: flex;
  position: fixed;
  z-index: 300000;
}
</style>
